module.exports = __webpack_public_path__ + "audio/oneAudio.01ea4587.mp3";